(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector-category', {
            parent: 'entity',
            url: '/sector-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-category/sector-categories.html',
                    controller: 'SectorCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorCategory');
                    $translatePartialLoader.addPart('sectorTypeCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-category-detail', {
            parent: 'entity',
            url: '/sector-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-category/sector-category-detail.html',
                    controller: 'SectorCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorCategory');
                    $translatePartialLoader.addPart('sectorTypeCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectorCategory', function($stateParams, SectorCategory) {
                    return SectorCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('sector-category.new', {
            parent: 'sector-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-category/sector-category-dialog.html',
                    controller: 'SectorCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                sectorTypeCategory: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector-category', null, { reload: true });
                }, function() {
                    $state.go('sector-category');
                });
            }]
        })
        .state('sector-category.edit', {
            parent: 'sector-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-category/sector-category-dialog.html',
                    controller: 'SectorCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SectorCategory', function(SectorCategory) {
                            return SectorCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector-category.delete', {
            parent: 'sector-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-category/sector-category-delete-dialog.html',
                    controller: 'SectorCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SectorCategory', function(SectorCategory) {
                            return SectorCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
